const Buffer = require('./buffer/Buffer');
const MousemoveOverlay = require('./mousemoveoverlay/MousemoveOverlay');
const SelectLocation = require('./selectLocation/SelectLocation');
/**
 * @namespace
 * @memberOf G
 * @alias G.interact
 * @description 地图交互类
 */
const components = {
    Buffer,MousemoveOverlay,SelectLocation
};
module.exports = components;
